import FontAwesomeIcon from "~/components/FontAwesome";
import _ from "lodash"
import {Link} from "react-router-dom";
import {useCan} from "../../hooks";

export const NavBarData = () => {

	const roles = {
		user  : useCan('user_list'),
		permission  : useCan('shop_roles'),
		customer: useCan('customer_list'),
		supplier: useCan('supplier_list'),
		attribute: useCan('attribute_list'),
		productCategory: useCan('products_categories_list'),
	}

	const navBarList = [
		{
			key: 'home',
			label: <Link to="/">Dashboard</Link>,
			title: 'Dashboard',
			to: '/',
			icon: <FontAwesomeIcon icon="fa-light fa-house" />,
			count: 0,
		},
		{
			key: 'user',
			label: <Link to="/user">Nhân viên</Link>,
			title: 'Nhân viên',
			to: '/user',
			icon: <FontAwesomeIcon icon="fa-light fa-user-group" />
		},
		{
			key: 'permission',
			label: <Link to="/permission">Phân quyền</Link>,
			title: 'Phân quyền',
			to: '/permission',
			icon: <FontAwesomeIcon icon="fa-light fa-user-shield" />,
		},
		{
			key: 'objectManagement',
			label: 'Đối tượng quản lý',
			title: 'Đối tượng quản lý',
			icon: <FontAwesomeIcon icon="fa-light fa-rectangle-list" />,
			children: [
				{
					key: 'customer',
					label: <Link to="/customer">Khách hàng</Link>,
					title: 'Khách hàng',
					to: '/customer',
					icon: <FontAwesomeIcon icon="fa-light fa-users" />,
				},
				{
					key: 'supplier',
					label: <Link to="/supplier">Nhà cung cấp</Link>,
					title: 'Supplier',
					to: '/supplier',
					icon: <FontAwesomeIcon icon="fa-light fa-handshake" />,
				}
			]
		},
		{
			key: 'goodManagement',
			label: 'Hàng hóa',
			title: 'Hàng hóa',
			icon: <FontAwesomeIcon icon="fa-light fa-rectangle-list" />,
			children: [
				{
					key: 'purchase-order',
					label: <Link to="/purchase-order">Nhập hàng</Link>,
					title: 'Nhập hàng',
					to: '/purchase-order',
					icon: <FontAwesomeIcon icon="fa-light fa-folder-tree" />,
				},
				{
					key: 'product',
					label: <Link to="/product">Sản phẩm</Link>,
					title: 'Sản phẩm',
					to: '/product',
					icon: <FontAwesomeIcon icon="fa-light fa-folder-tree" />,
				},
				{
					key: 'productCategory',
					label: <Link to="/product-category">Danh mục sản phẩm</Link>,
					title: 'Danh mục sản phẩm',
					to: '/product-category',
					icon: <FontAwesomeIcon icon="fa-light fa-folder-tree" />,
				},
				{
					key: 'attribute',
					label: <Link to="/attribute">Thuộc tính</Link>,
					title: 'Thuộc tính',
					to: '/attribute',
					icon: <FontAwesomeIcon icon="fa-light fa-tags" />,
				}
			]
		},
		{
			key: 'order',
			label: <Link to="/order">Đơn hàng</Link>,
			title: 'Đơn hàng',
			to: '/order',
			icon: <FontAwesomeIcon icon="fa-light fa-file-invoice" />,
		},
		{
			key: 'report',
			label: 'Báo cáo',
			title: 'Báo cáo',
			icon: <FontAwesomeIcon icon="fa-light fa-chart-line" />,
			children: [
				{
					key: 'revenue-report',
					label: <Link to="/report/revenue">Doanh thu</Link>,
					title: 'Báo cáo Doanh thu',
					to: '/report/revenue',
					icon: <FontAwesomeIcon icon="fa-light fa-chart-bar" />,
				},
				{
					key: 'revenue-by-user',
					label: <Link to="/report/revenue-by-user">Theo người bán</Link>,
					title: 'Doanh thu theo người bán',
					to: '/report/revenue-by-user',
					icon: <FontAwesomeIcon icon="fa-light fa-user-chart" />,
				},
				{
					key: 'revenue-by-product',
					label: <Link to="/report/revenue-by-product">Theo sản phẩm</Link>,
					title: 'Doanh thu theo sản phẩm',
					to: '/report/revenue-by-product',
					icon: <FontAwesomeIcon icon="fa-light fa-chart-pie" />,
				}
			]
		},
	];

	function removeItem(navBarList, itemKey)
	{
		_.remove(navBarList, function(item)
		{
			return item.key === itemKey;
		});
	}

	function removeSubItem(navBarList, itemIndex, subItemKey)
	{
		_.forEach(navBarList, function(menu, index)
		{
			if (menu?.key)
			{
				if(menu?.key === itemIndex)
				{
					_.remove(navBarList[index]?.children, function(item)
					{
						return item.key === subItemKey;
					});
					//break foreach
					return false;
				}
			}
		});
	}

	if(!roles.user)
	{
		removeItem(navBarList, 'user')
	}
	if(!roles.permission)
	{
		removeItem(navBarList, 'permission')
	}
	if(!roles.customer)
	{
		removeSubItem(navBarList, 'objectManagement', 'customer')
	}
	if(!roles.supplier)
	{
		removeSubItem(navBarList, 'objectManagement', 'supplier')
	}
	if(!roles.productCategory)
	{
		removeSubItem(navBarList, 'goodManagement', 'productCategory')
	}
	if(!roles.attribute)
	{
		removeSubItem(navBarList, 'goodManagement', 'attribute')
	}

	_.forEach(navBarList, function(menu, index)
	{
		if (menu?.children)
		{
			if(menu?.children.length === 0)
			{
				navBarList[index] = null;
			}
			else if(menu?.children.length === 1)
			{
				navBarList[index].label = menu?.children[0].label;
				navBarList[index].icon = menu?.children[0].icon;
				navBarList[index].children = undefined;
			}
		}
	});

	return navBarList;
}